import http from "./httpService";

export function getCourses() {
  return http.get("/courses");
}